/* global axios */
import ApiClient from './ApiClient';

class TaskCommentsAPI extends ApiClient {
  constructor() {
    super('tasks', { accountScoped: true });
  }

  create(taskId, payload) {
    return axios.post(`${this.url}/${taskId}/comments`, payload);
  }

  update(taskId, id, payload) {
    return axios.patch(`${this.url}/${taskId}/comments/${id}`, payload);
  }

  remove(taskId, id) {
    return axios.delete(`${this.url}/${taskId}/comments/${id}`);
  }
}

export default new TaskCommentsAPI();
